// extracted by mini-css-extract-plugin
export var cardLayout = "_b1-1";
export var paginationContainer = "_b1-0";